import { useAuth } from '@/lib/auth/auth';
import { useWorkspaceCapability } from '@/features/workspaces/useWorkspaceCapability';

export function useWorkspaceMode() {
  const session = useAuth((state) => state.session);
  const { currentVersion, minimumVersion, supportsOrgWorkspace } = useWorkspaceCapability();
  const orgAccessEnabled = Boolean(session) && supportsOrgWorkspace;

  return {
    currentVersion,
    minimumVersion,
    supportsOrgWorkspace,
    mode: orgAccessEnabled ? ('org-enabled' as const) : ('unsupported' as const),
    orgAccessEnabled,
  };
}
